<template>
  <div v-if="isLanRoot">
    <h1 class="subpage-header">
      {{ t('umsoknundirsida_text_header') }}
    </h1>

    <div class="linkbox-grid">
      <LinkActionBox
        v-for="link in lanLinks"
        :key="link.url"
        :title="link.title"
        :url="link.url"
        :disabled="link.disabled"
        button-text="Sækja um"
        class="link-action-box"
      />
    </div>
  </div>
  <router-view />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
import LinkActionBox from '@/components/shared/LinkActionBox.vue'

const { t } = useI18n()
const router = useRouter()
const route = useRoute()

const umsoknirRoot = computed(() => router.getRoutes().find(r => r.path === '/umsoknir'))
const categoryRoutes = computed(() => umsoknirRoot.value?.children ?? [])
const isLanRoot = computed(() => route.path === '/umsoknir/lan')

const lanLinks = computed(() => {
  const cat = categoryRoutes.value.find(r => r.path === 'lan')
  return cat?.children?.map(child => ({
    title: t(String(child.meta?.titleKey || child.name || '—')),
    url: `/umsoknir/lan/${child.path}`,
    disabled: child.meta?.disabled === true
  })) ?? []
})

</script>



<style scoped lang="scss">
@use "@/scss/settings/variables" as var;
.subpage-header {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 32px;
}
 
.linkbox-grid {
  display: flex;
  flex-direction: column;
  gap: var.$gap-md;

}

</style>
